// Style of tap highlight
export const baseHighlightStyle = `
  -webkit-tap-highlight-color: transparent;
  ::-moz-focus-inner {
    border: 0;
  }
`;